export const addLinks = [
  { name: 'Plaatsen', path: '/plaatsen', icon: '+' },
  { name: 'Vraag', path: '/vraag', icon: '?' },
];
